module.exports = __webpack_public_path__ + "static/lemonchickonesie2-feae179aebe6298c433517efaec25e9d.jpeg";